import { getContentTypeBuilder } from "./getContentType";
import { getHeaderBannerBuilder } from "./getHeaderBanner";
import { getHeaderItemsBuilder } from "./getHeaderItems";
import { getLandingPagesBuilder } from "./getLandingPages";
import { getSlidingBannerBuilder } from "./getSlidingBanner";
import { IContent } from "./interfaces";
import { getCmsNetworkClient } from "./networkClient";
import { createContentTypeV2Builder } from "./createContentTypeV2";
import { getContentTypeV2Builder } from "./getContentTypeV2";
import { updateContentTypeV2Builder } from "./updateContentTypeV2";
import { puckEditorLoginBuilder } from "./puckEditorLogin";
import { getContentTypesBuilder } from "./getContentTypes";
import { getContentTypeBySlugBuilder } from "./getContentTypeBySlug";
import { duplicateContentTypeBuilder } from "./duplicateContentType";
import { getHeaderProfilesBuilder } from "./getHeaderProfiles";
import { getHeaderItemByIdBuilder } from "./getHeaderItemById";

export function getCmsApiClientFunctions(options?: {
  token?: string;
}): IKunduzContentApiClient {
  const apiClient = getCmsNetworkClient(options?.token);

  const functions = {
    getContentType: getContentTypeBuilder(apiClient),
    getLandingPages: getLandingPagesBuilder(apiClient),
    getHeaderItems: getHeaderItemsBuilder(apiClient),
    getHeaderBanner: getHeaderBannerBuilder(apiClient),
    getSlidingBanner: getSlidingBannerBuilder(apiClient),
    getContentTypeV2: getContentTypeV2Builder(apiClient),
    createContentTypeV2: createContentTypeV2Builder(apiClient),
    updateContentTypeV2: updateContentTypeV2Builder(apiClient),
    puckEditorLogin: puckEditorLoginBuilder(apiClient),
    getContentTypes: getContentTypesBuilder(apiClient),
    getContentTypeBySlug: getContentTypeBySlugBuilder(apiClient),
    duplicateContentType: duplicateContentTypeBuilder(apiClient),
    getHeaderProfiles: getHeaderProfilesBuilder(apiClient),
    getHeaderItemById: getHeaderItemByIdBuilder(apiClient),
  };

  return functions;
}
interface IKunduzContentApiClient {
  /**
   * returns content meta given page slug
   * content meta contains type of page and some variables to query for the actual data
   */
  getContentType: (
    slug: string,
  ) => Promise<IContent.IContentTypeResponse | null>;
  getLandingPages: (options?: {
    "slug-prefix"?: string;
    "slug-prefix-exclude"?: string;
    lang?: "tr" | "en";
  }) => Promise<IContent.IContentTypeResponse[]>;
  getHeaderItems: (options: {
    profile: string;
    lang?: string;
  }) => Promise<IContent.HeaderItemsResponse | null>;
  getHeaderBanner: (options: {
    lang?: string;
  }) => Promise<IContent.HeaderBannerResponse | null>;
  getSlidingBanner: (options: {
    lang?: string;
  }) => Promise<IContent.SlidingBannerResponse | null>;
  getContentTypeV2: (uuid: string) => Promise<any | null>;
  createContentTypeV2: (data: { content: any }) => Promise<any | null>;
  updateContentTypeV2: (
    id: string,
    data: { content: any },
  ) => Promise<any | null>;
  puckEditorLogin: (email: string, password: string) => Promise<any | null>;
  getContentTypes: (
    page: number,
    searchTerm?: string,
  ) => Promise<{
    count: number;
    results: IContent.ContentType[];
    previous?: string;
    next?: string;
  }>;
  getContentTypeBySlug: (slug: string) => Promise<any | null>;
  duplicateContentType: (uuid: string) => Promise<any | null>;
  getHeaderProfiles: () => Promise<IContent.HeaderProfileResponse | null>;
  getHeaderItemById: (
    id: number,
  ) => Promise<IContent.HeaderItemsResponse | null>;
}
